// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import mixins from './mixins'
import 'lib-flexible/flexible.js'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'normalize.css'
import {Alert, Confirm, Toast} from 'wc-messagebox'
import { Swipe, SwipeItem } from 'mint-ui'
import 'wc-messagebox/style.css'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import axiosPlugin from './utils/axios'
import * as filters from './filters'
import './common/stylus/index.styl';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
require('es6-promise').polyfill()
// require('./assets/js/vconsole.js')
Es6Promise.polyfill()
// register global mixins.
// 注册
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

Vue.mixin(mixins)

Vue.use(Mint)
Vue.use(axiosPlugin)

Vue.use(Alert)
Vue.use(Confirm)
Vue.use(Toast)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})



// import { Swipe, SwipeItem } from 'mint-ui';

// Vue.component(Swipe.name, Swipe);
// Vue.component(SwipeItem.name, SwipeItem);

Vue.config.productionTip = false
router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  // if (!window.initUrl) {
  //   window.initUrl = location.href.split('#')[0]
  // }
  next()

})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js